import { RoulettePocket } from '../enums/RoulettePocket';
var RoulettePocketsDefinition = /** @class */ (function () {
    function RoulettePocketsDefinition() {
    }
    RoulettePocketsDefinition.dozen = {
        first: Object.values(RoulettePocket).filter(function (pocket) {
            return ![RoulettePocket.POCKET_0, RoulettePocket.POCKET_00].includes(pocket) && Number(pocket) <= 12;
        }),
        second: Object.values(RoulettePocket).filter(function (pocket) { return Number(pocket) > 12 && Number(pocket) <= 24; }),
        third: Object.values(RoulettePocket).filter(function (pocket) { return Number(pocket) > 24; }),
    };
    RoulettePocketsDefinition.column = {
        first: Object.values(RoulettePocket).filter(function (pocket) { return Number(pocket) % 3 === 1; }),
        second: Object.values(RoulettePocket).filter(function (pocket) { return Number(pocket) % 3 === 2; }),
        third: Object.values(RoulettePocket).filter(function (pocket) {
            return ![RoulettePocket.POCKET_0, RoulettePocket.POCKET_00].includes(pocket) &&
                Number(pocket) % 3 === 0;
        }),
    };
    RoulettePocketsDefinition.low = Object.values(RoulettePocket).filter(function (pocket) { return ![RoulettePocket.POCKET_0, RoulettePocket.POCKET_00].includes(pocket) && Number(pocket) <= 18; });
    RoulettePocketsDefinition.high = Object.values(RoulettePocket).filter(function (pocket) { return Number(pocket) > 18; });
    RoulettePocketsDefinition.even = Object.values(RoulettePocket).filter(function (pocket) {
        return ![RoulettePocket.POCKET_0, RoulettePocket.POCKET_00].includes(pocket) && Number(pocket) % 2 === 0;
    });
    RoulettePocketsDefinition.odd = Object.values(RoulettePocket).filter(function (pocket) { return Number(pocket) % 2 === 1; });
    RoulettePocketsDefinition.color = {
        green: [RoulettePocket.POCKET_0, RoulettePocket.POCKET_00],
        black: [
            RoulettePocket.POCKET_2,
            RoulettePocket.POCKET_4,
            RoulettePocket.POCKET_6,
            RoulettePocket.POCKET_8,
            RoulettePocket.POCKET_10,
            RoulettePocket.POCKET_11,
            RoulettePocket.POCKET_13,
            RoulettePocket.POCKET_15,
            RoulettePocket.POCKET_17,
            RoulettePocket.POCKET_20,
            RoulettePocket.POCKET_22,
            RoulettePocket.POCKET_24,
            RoulettePocket.POCKET_26,
            RoulettePocket.POCKET_28,
            RoulettePocket.POCKET_29,
            RoulettePocket.POCKET_31,
            RoulettePocket.POCKET_33,
            RoulettePocket.POCKET_35,
        ],
        red: [
            RoulettePocket.POCKET_1,
            RoulettePocket.POCKET_3,
            RoulettePocket.POCKET_5,
            RoulettePocket.POCKET_7,
            RoulettePocket.POCKET_9,
            RoulettePocket.POCKET_12,
            RoulettePocket.POCKET_14,
            RoulettePocket.POCKET_16,
            RoulettePocket.POCKET_18,
            RoulettePocket.POCKET_19,
            RoulettePocket.POCKET_21,
            RoulettePocket.POCKET_23,
            RoulettePocket.POCKET_25,
            RoulettePocket.POCKET_27,
            RoulettePocket.POCKET_30,
            RoulettePocket.POCKET_32,
            RoulettePocket.POCKET_34,
            RoulettePocket.POCKET_36,
        ],
    };
    RoulettePocketsDefinition.frenchSection = {
        zero: [
            RoulettePocket.POCKET_0,
            RoulettePocket.POCKET_00,
            RoulettePocket.POCKET_3,
            RoulettePocket.POCKET_12,
            RoulettePocket.POCKET_26,
            RoulettePocket.POCKET_32,
            RoulettePocket.POCKET_35,
        ],
        orphelins: [
            RoulettePocket.POCKET_1,
            RoulettePocket.POCKET_6,
            RoulettePocket.POCKET_9,
            RoulettePocket.POCKET_14,
            RoulettePocket.POCKET_17,
            RoulettePocket.POCKET_20,
            RoulettePocket.POCKET_31,
            RoulettePocket.POCKET_34,
        ],
        tier: [
            RoulettePocket.POCKET_5,
            RoulettePocket.POCKET_8,
            RoulettePocket.POCKET_10,
            RoulettePocket.POCKET_11,
            RoulettePocket.POCKET_13,
            RoulettePocket.POCKET_16,
            RoulettePocket.POCKET_23,
            RoulettePocket.POCKET_24,
            RoulettePocket.POCKET_27,
            RoulettePocket.POCKET_30,
            RoulettePocket.POCKET_33,
            RoulettePocket.POCKET_36,
        ],
        voisins: [
            RoulettePocket.POCKET_0,
            RoulettePocket.POCKET_00,
            RoulettePocket.POCKET_2,
            RoulettePocket.POCKET_3,
            RoulettePocket.POCKET_4,
            RoulettePocket.POCKET_7,
            RoulettePocket.POCKET_12,
            RoulettePocket.POCKET_15,
            RoulettePocket.POCKET_18,
            RoulettePocket.POCKET_19,
            RoulettePocket.POCKET_21,
            RoulettePocket.POCKET_22,
            RoulettePocket.POCKET_25,
            RoulettePocket.POCKET_26,
            RoulettePocket.POCKET_28,
            RoulettePocket.POCKET_29,
            RoulettePocket.POCKET_32,
            RoulettePocket.POCKET_35,
        ],
    };
    return RoulettePocketsDefinition;
}());
export { RoulettePocketsDefinition };
